export const USER_ROLES = Object.freeze({
  HEAD_OFFICE: "Head Office",
  BRANCH_OFFICE: "Kantor Cabang",
  INSURED: "insured",
  WORKSHOP: "workshop",
});

const AUTH_STORAGE_KEYS = ["token", "userRole", "expires", "persist:root"];

export const getLoginPathForRole = (role) =>
  role === USER_ROLES.INSURED || role === USER_ROLES.WORKSHOP ? "/login/insured" : "/";

export const getDashboardPathForRole = (role) => {
  switch (role) {
    case USER_ROLES.HEAD_OFFICE: return "/dashboard-headoffice";
    case USER_ROLES.BRANCH_OFFICE: return "/dashboard-branch";
    case USER_ROLES.INSURED: return "/dashboard-insured/bengkel";
    case USER_ROLES.WORKSHOP: return "/dashboard-workshop";
    default: return "/";
  }
};

const getJwtExpiry = (token) => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const normalized = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const decoded = JSON.parse(window.atob(normalized));
    return Number.isFinite(decoded.exp) ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
};

const normalizeExpiry = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) {
    return numericValue < 1_000_000_000_000 ? numericValue * 1000 : numericValue;
  }

  const parsedDate = Date.parse(value);
  return Number.isNaN(parsedDate) ? null : parsedDate;
};

export const clearAuthSession = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const saveAuthSession = ({ token, role, expires }) => {
  if (!token || !role) {
    throw new Error("Data sesi dari server tidak lengkap.");
  }

  const expiry = normalizeExpiry(expires) ?? getJwtExpiry(token);
  localStorage.setItem("token", token);
  localStorage.setItem("userRole", role);

  if (expiry) localStorage.setItem("expires", String(expiry));
  else localStorage.removeItem("expires");
};

export const getAuthSession = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  const storedExpiry = normalizeExpiry(localStorage.getItem("expires"));
  const expires = storedExpiry ?? (token ? getJwtExpiry(token) : null);

  return { token, role, expires };
};

export const isSessionExpired = ({ expires } = getAuthSession()) =>
  expires !== null && Date.now() >= expires;

export const getValidAuthSession = () => {
  const session = getAuthSession();
  if (!session.token || !session.role || isSessionExpired(session)) {
    clearAuthSession();
    return null;
  }
  return session;
};

export const hasValidSession = (allowedRoles = []) => {
  const session = getValidAuthSession();
  if (!session) return false;
  const { role } = session;
  const isAllowedRole = allowedRoles.length === 0 || allowedRoles.includes(role);
  return isAllowedRole;
};
